import React, { useState, useEffect, useRef, memo } from 'react';
import {
    Box,
    Typography,
    TextField,
    Button,
    CircularProgress,
} from '@mui/material';
import { inputStyles } from './styles';

const SummarySection = memo(({ 
    initialData, 
    authAxios, 
    setError, 
    onUpdate 
}) => {
    const summaryRef = useRef(null);
    const [summary, setSummary] = useState(initialData || '');
    const [saving, setSaving] = useState(false);

    useEffect(() => {
        if (initialData !== undefined) {
            setSummary(initialData);
        }
    }, [initialData]);

    const handleSave = async () => {
        const currentSummary = summaryRef.current?.value || summary;
        
        setSaving(true);
        try {
            const response = await authAxios.patch('/self/', {
                bio: currentSummary,
            });
            
            setSummary(response.data.bio || '');
            onUpdate?.(response.data.bio || '');
        } catch (error) {
            console.error('Failed to save summary:', error);
            const errorMsg = error.response?.data?.detail || error.response?.data?.message || 'Failed to save summary';
            setError?.(errorMsg);
        } finally {
            setSaving(false);
        }
    };

    return (
        <Box sx={{ mb: 6 }}>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
                <Typography variant="h6" sx={{ fontSize: '1.5rem', fontWeight: 600, color: '#111827' }}>
                    Summary
                </Typography>
                <Button
                    variant="contained"
                    onClick={handleSave}
                    disabled={saving}
                    sx={{
                        bgcolor: '#4f46e5',
                        color: 'white',
                        textTransform: 'none',
                        fontWeight: 500,
                        borderRadius: '6px',
                        px: 3,
                        '&:hover': { bgcolor: '#4338ca' },
                    }}
                >
                    {saving ? <CircularProgress size={20} color="inherit" /> : 'Save'}
                </Button>
            </Box>

            <TextField
                fullWidth
                size="small"
                multiline
                rows={3}
                placeholder="Write a brief summary about yourself..."
                defaultValue={summary}
                inputRef={summaryRef}
                sx={inputStyles}
            />
        </Box>
    );
});

SummarySection.displayName = 'SummarySection';

export default SummarySection;
